import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {TeamHealthScoreVm} from '../../models/team-dynamic-team.vm';

@Component({
  selector: 'app-team-health-score',
  templateUrl: './team-health-score.component.html',
  styleUrls: ['./team-health-score.component.scss']
})
export class TeamHealthScoreComponent implements OnChanges {
  @Input() data: TeamHealthScoreVm | null = null;

  teamBarStyle: { [key: string]: string } = {};
  workspaceBarStyle: { [key: string]: string } = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.buildBars();
    }
  }

  private buildBars() {
    this.teamBarStyle = {width: this.clamp(this.data?.score) + '%'};
    this.workspaceBarStyle = {width: this.clamp(this.data?.workspaceScore) + '%'};
  }

  private clamp(value: number | null | undefined): number {
    if (value === null || value === undefined) {
      return 0;
    }
    return Math.min(100, Math.max(0, value));
  }
}
